import { s as t, k as a, l as n } from "./index-BmGD5jiK.js";
let s = null;
const o = (e) => {
  s = e;
}, r = () => s, u = (e) => {
  t(e.env), o(e.source), e.getAuthTokenCallback && a(e.getAuthTokenCallback), e.axiosInstance && n(e.axiosInstance);
};
export {
  r as g,
  u as i
};
